import last from 'lodash/last';
import { useState, useMemo } from 'react';
import { useDebouncedCallback, useWindowResize } from 'beautiful-react-hooks';

export enum ScreenSize {
  ExtraSmall = 425,
  Small = 640,
  Medium = 768,
  ExtraMedium = 850,
  Large = 1024,
  ExtraLarge = 1280,
  ExtraExtraLarge = 1536,
}

const screenSizeThresholds = [
  ScreenSize.ExtraSmall,
  ScreenSize.Small,
  ScreenSize.Medium,
  ScreenSize.ExtraMedium,
  ScreenSize.Large,
  ScreenSize.ExtraLarge,
  ScreenSize.ExtraExtraLarge,
];

export function useScreenSize(): ScreenSize {
  const [screenWidth, setScreenWidth] = useState(window.screen.width);

  const updateScreenWidth = useDebouncedCallback(
    () => {
      setScreenWidth(window.screen.width);
    },
    [setScreenWidth],
    500
  );

  useWindowResize()(updateScreenWidth);

  return useMemo(
    () =>
      last(screenSizeThresholds.filter((s) => s < screenWidth)) ??
      ScreenSize.ExtraSmall,
    [screenWidth]
  );
}
